jQuery(document).ready(function ($) {

    var video = document.getElementById("video-1");
    // if video element is not present, return
    if (video) {

        video.addEventListener("loadeddata", function () {
            $("body").removeClass("pending-animations")
            window.setTimeout(function () {
                $("body").addClass("ready-to-animate");

            }, 250);

        });
    }

    // on hero-video section, scroll to next section
    const $scrollReadmore = $('#scroll-readmore');
    $scrollReadmore.on('click', function (e) {
        e.preventDefault();
        $nextSection = $(this).closest('section').next();
        $('html, body').animate({
            scrollTop: $nextSection.offset().top
        }, 600);
    });

});
